export interface ConversationItem {
  id: string; // Added a unique id for React keys
  log_id: string;
  type: 'query' | 'general' | 'explaination' | 'response' | 'data_table' | string; // Extend as needed based on actual message types
  // Changed 'object' to 'Record<string, unknown>'
  msg: string | Record<string, unknown>; // 'msg' can be a string or an object (e.g., for structured data/tables)
}

export interface AiState {
  aiVisible: boolean;
  conversationList: ConversationItem[];
}

export const aiState: AiState = {
  aiVisible: false,
  conversationList: [],
};
